import { useQuery } from '@tanstack/react-query';
import { getConnectionData } from '@/helpers/url';
import { allGameRoundsQuery } from '@/ui/api/connector/queries';
import { formatCurrency } from '@/ui/lib/utils';
import { Spinner, Table } from '@/ui/components/base';
import { useStore } from '@/store/useStore';
import './allGameRounds.css';

export const AllGameRounds = () => {
    const userRef = useStore((state) => state.userRef);
    const { data } = useQuery(allGameRoundsQuery(userRef, getConnectionData().gameId, 50, 0));

    if (!data) {
        return (
            <div className="all-game-rounds__spinner">
                <Spinner />
            </div>
        );
    }

    return (
        <Table className="all-game-rounds">
            <Table.Header>
                <Table.Row>
                    <Table.Head>Date & Time</Table.Head>
                    <Table.Head>Bet</Table.Head>
                    <Table.Head>
                        <strong>Win</strong>
                    </Table.Head>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {data.map((round) => (
                    <Table.Row className="all-game-rounds__row" key={round.id}>
                        <Table.Cell>{new Date(round.date).toLocaleString()}</Table.Cell>
                        <Table.Cell>{formatCurrency(round.bet / 100, 'GBP')}</Table.Cell>
                        <Table.Cell>
                            <strong>{formatCurrency(round.win / 100, 'GBP')}</strong>
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );
};
